<template>
    <div>
        <div class="ruleFormCode uconfigResetpwd" >
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" 
                    :label-width="widthNew?'120px':'35%'"
                    >
                        <el-form-item label="手机号码：" prop="phone">
                            <el-input v-model="ruleForm.phone" placeholder="请输入手机号" ></el-input>
                        </el-form-item>
                        
                        <el-form-item label="短信验证码：" prop="phoneCode">
                            <el-input class="codeInput" v-model="ruleForm.phoneCode" placeholder="请输入手机验证码"></el-input>
                            <el-button class="codeButton" @click="HandleCode">{{widthNew ?'获取短信验证码':'验证码' }}</el-button>
                        </el-form-item>
                   
                        <el-form-item label="请输入新密码" prop="password">
                            <el-input v-model="ruleForm.password" placeholder="请输入新密码"  type="password" ></el-input>
                        </el-form-item>
                        <el-form-item label="请确认新密码" prop="newPassword">
                            <el-input v-model="ruleForm.newPassword" placeholder="请确认新密码" type="password"></el-input>
                            
                        </el-form-item>
<!--                         
                        <el-form-item style="border: none;">
                            <el-button type="primary" class="restButtonForget" v-show="activeType == 1" @click="resetpwd">确认</el-button>
                        </el-form-item> -->
                    </el-form>
                    <div style="border: none;">
                        <el-button type="primary" class="restButtonForget" v-show="activeType == 1" @click="resetpwd">确认</el-button>
                    </div>

                    <div >
                        <el-result icon="success" title="密码修改成功"  v-show="activeType == 2">
                            <template slot="extra">
                                <router-link to="/login"><el-button type="primary" size="medium">返回登陆页</el-button></router-link>
                            </template>
                        </el-result>
                    </div>
                </div>
    </div>
</template>
<script>
export default{
    data(){
        var validatePassword = (rule, value, callback) => {
            const regex = /^(?=.*[a-z])(?=.*[A-Z]).+$/;
            if (!regex.test(value)) {
                callback(new Error('密码必须包含大小写字母'));
            } else {
                callback();
            }
        }
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.newPassword !== '') {
            this.$refs.ruleForm.validateField('newPassword');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
        return{
            activeType: 1,
            value: '',
            options: [{
                value: '选项1',
                label: '黄金糕'
                }, {
                value: '选项2',
                label: '双皮奶'
                }, {
                value: '选项3',
                label: '蚵仔煎'
                }, {
                value: '选项4',
                label: '龙须面'
                }, {
                value: '选项5',
                label: '北京烤鸭'
            }],
            ruleForm: {
                phone: '',
                code: '',
                phoneCode: '',
                newPassword: '',
                password: ''
            },
            rules: {
                phone: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                    { min: 11, max: 11, message: '请正确输入手机号码', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'change' }
                ],
                phoneCode: [
                    {  required: true, message: '请输入手机验证码', trigger: 'change' }
                ],
                password: [
                    { required: true, message: '请输入新密码', trigger: 'blur',validator: validatePass },
                    { validator: validatePassword, trigger: 'blur' }
                ],
                newPassword: [
                    { required: true,validator: validatePass2}
                ],
            },
            rulesNew: {
                
            },
            widthNew: false
        }
       
        
    },
    methods: {
        HandleCode(val){
            // this.activeType =val  2
            let data = {
                ac: 'appvercode',
                phone: this.ruleForm.phone,
                usecate: "resetpwd",
                expireTime: '5'
            }
            this.$store.dispatch('login/sendsms',data)
                .then(res => {
                    if(res.ok){
                        console.log("ces------------------");
                        console.log(res);
                        this.$alert('发送成功', '提示',{
                            confirmButtonText: '确定',
                        })
                    }else{
                        this.$alert(res.msg,'提示',{
                            confirmButtonText: '确定'
                        })
                    }
                })

        },
        resetpwd(){
            console.log("cs");
            this.$refs.ruleForm.validate((valid) => {
                    
                if (valid) {
                    let data = {
                        user_mobile: this.ruleForm.phone,
                        smscode: this.ruleForm.phoneCode,
                        user_password: this.ruleForm.password
                    }

                    this.$store.dispatch('login/resetPwd',data)
                        .then(res => {
                            if(res.ok){
                                this.$alert('修改密码成功','提示',{
                                    cancelButtonText: '确定'
                                })
                                this.activeType = 2
                            }else{
                                this.$alert(res.msg,'提示',{
                                    cancelButtonText: '确定'
                                })
                            }
                        }).catch(err => {

                        })
                }
            })
            
        }
    },
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
    }
}
</script>
<style scoped>
::v-deep .uconfigResetpwd .el-input__inner{
    border: none !important;
}
::v-deep .uconfigResetpwd .el-form-item {
    margin-bottom: 40px !important;
    padding-bottom: 16px !important;
    border-bottom: 0.5px solid #f2f2f2 !important;
}
::v-deep .uconfigResetpwd .el-form-item__error{
    padding-left: 15px !important;
}
.ruleFormCode{
    width: 770px;
    margin: 0px auto;
}
.ruleFormCode .el-input{
    width: 388px;
    height: 42px;
}

.restButtonForget{
   width: 332px;height: 40px;
   background: #4095e5;
   color: #ffffff;
   border: 1px solid #4095e5;
   margin-top: 20px;
   align-items: center;
}
.codeButton{
    /* width: 125px;height: 42px; */
    margin-left: 90px;
    background: #f2f2f2;
}
.ruleFormCode .img{
    width: 123px;height: 39px;
    float: right;
    margin-right: 13px;
    border: 1px solid #e5e5e5;
}
.ruleFormCode span{
    float: right;
    cursor: pointer;
    color: #666666;
    font-size: 12px;
}
.ruleFormCode span:hover{
    float: right;
    cursor: pointer;
    color: #f74747;
}
@media screen and (max-width: 540px) {
    
    .ruleFormCode{
        width: 100%;
        margin: 0px auto;
    }
    .ruleFormCode .el-input{
        width: 95%;
        height: 42px;
    }
    ::v-deep .codeInput{
        width: 50% !important;
    }
    .codeButton{
    /* width: 125px;height: 42px; */
        margin-left: 10px;
        background: #f2f2f2;
    }
}
</style>